module.exports = __webpack_public_path__ + "img/img53.d72f2578.png";